<template>
  <div>demo3-2/index</div>
</template>

<script>
export default {

}
</script>

<style>

</style>